import type { CSSProperties } from 'react';

// Shared by every settings panel, including the advanced editor.
export const settingsCardStyle: CSSProperties = {
  minWidth: 0,
  scrollMarginTop: 88,
  overflowWrap: 'anywhere',
  padding: 20,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--surface)',
  color: 'var(--text)',
  fontSize: 13,
  lineHeight: 1.5,
};

export const settingsHeadingStyle: CSSProperties = {
  margin: 0,
  fontSize: 15,
  fontWeight: 700,
  lineHeight: 1.4,
  color: 'var(--text)',
};

export const settingsDescriptionStyle: CSSProperties = {
  margin: '4px 0 0',
  fontSize: 12,
  lineHeight: 1.5,
  color: 'var(--text-muted)',
};

export const settingRowStyle: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px 16px',
  padding: '12px 0',
  borderTop: '1px solid var(--border)',
};

export const settingLabelColumnStyle: CSSProperties = { flex: '1 1 240px', minWidth: 0 };
export const settingLabelStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 14,
  fontWeight: 600,
  color: 'var(--text)',
};
export const settingOrgIndicatorStyle: CSSProperties = {
  ...settingsDescriptionStyle,
  fontSize: 11,
  fontStyle: 'italic',
};

export const settingsInputStyle: CSSProperties = {
  maxWidth: '100%',
  minHeight: 34,
  padding: '6px 10px',
  borderRadius: 6,
  border: '1px solid var(--border)',
  background: 'var(--surface)',
  color: 'var(--text)',
  fontSize: 13,
};

export const settingsButtonStyle: CSSProperties = {
  ...settingsInputStyle,
  fontWeight: 600,
  cursor: 'pointer',
};

export function settingsPrimaryButtonStyle(disabled = false): CSSProperties {
  return {
    ...settingsButtonStyle,
    background: disabled ? 'var(--surface2)' : 'var(--accent)',
    color: disabled ? 'var(--text-muted)' : '#fff',
    borderColor: disabled ? 'var(--border)' : 'var(--accent)',
    cursor: disabled ? 'not-allowed' : 'pointer',
  };
}
